import React from 'react';
import './admin-login.css'
import AdminLoginCard from '../components/AdminLoginCard';

const adminlogin = () => {
  return (
      <div className='login-page'>
        <div className='login-container'>
          <AdminLoginCard/>
        </div>
      </div>
  );
};

export default adminlogin;